/* const API_GATEWAY= "http://localhost:3000"; */
const API_GATEWAY= "https://api.n4-dev.csbservicios.com/n4";
const BXI_API_GATEWAY= "https://bxi-dev.csbservicios.com/n4";
const API_PROTECT_ROUTE = "https://648cccb08620b8bae7ed63d6.mockapi.io/api/";
const APIKEY = "bjRfYWNjb3VudHM6c2VjcmV0"
const LICENSEIDENTY ="QUVTAgAAAHE7LAfSzSAdVuDoe1Gl/zMakykp99wOvYbYluzs+y2RMpVRulxlOXFNdKYtSQojc/X21TGypWsU6GyKtvOFq8+vnJd18j+LqtEYKrOLJU0y7ixJ3cHnALyYnH4eC4QeUhlnVP9xCxLqnYaMICQqsnEE9GA1DCabBHLrZzC7qsvmoO4ELwu6KYZODjF/s7SB7mU=";
const isDev = false;

declare global {
    interface Window {
        ReactNativeWebView:any;
        'OCR_SDK_ASSETS':any
    }
}


export {
	API_GATEWAY,
    BXI_API_GATEWAY,
    API_PROTECT_ROUTE,
    APIKEY,
    isDev, 
    LICENSEIDENTY
};
